module.exports = __webpack_public_path__ + "static/media/menuFiltros.0adbfb32.png";